import React from 'react';
import { Field, change, getFormValues } from 'redux-form';
import { ReduxControls, ErrorBanner } from '@flashtalking/rhombus-react';
import { useDispatch, useSelector } from 'react-redux';

import { adSizes } from './CreateDisplayConceptModal';
import { replace } from 'connected-react-router';

import { saveConcept } from "reducers/ConceptDetails";
import { loadCreatives } from "reducers/Creatives";
import CustomSizes from "widgets/modals/creatives/CustomSizes";

import './SelectCreativeTypeNew.css';

export default function SelectCreativeTypeNew(props) {
	const {
			handleSubmit,
			libraryId,
			setIsLoading,
			returnPath,
			errorMessages,
			customSizes,
			formErrors,
			formName,
			headerText,
		} = props

		, dispatch = useDispatch()
		, isAllSelected = useSelector((state) => {
			let baseSizes = getFormValues(formName)(state)['base-sizes'] || {};
			let filtered = Object.values(baseSizes).filter(value => value);
			return filtered.length === adSizes.length;
		});

	const handleSelectAll = () => {
		if(isAllSelected){
			adSizes.map(fld=>dispatch(change(formName, `base-sizes[${fld}]`, false)));
		} else {
			adSizes.map(fld=>dispatch(change(formName, `base-sizes[${fld}]`, true)));
		}
	};

	function renderHeader() {
		if(customSizes && errorMessages.length) {
			let msgSet = new Set(errorMessages);
			return <ErrorBanner title="Sorry, please fix the errors below and try again." messages={[...msgSet]} />;
		} else {
			return <strong>{ headerText }</strong>;
		}
	}
	const makeConcept = handleSubmit((values) => {
		setIsLoading(true);
		dispatch(saveConcept(libraryId, buildConceptSizes(values, libraryId))).then((resp) => {
			setIsLoading(false);
			if(resp.success) {
				dispatch(loadCreatives(libraryId));
				dispatch(replace(returnPath));
			}
		});
	});

	return (
		<div className="select-ad creative-type">
			<header className="header-info">
				{renderHeader()}
			</header>
			<form className="checkbox-container" id={formName} onSubmit={makeConcept}>
				<div className="checkbox-col">
					<ReduxControls.Checkbox
						label="Standard Placement Sizes"
						name="standardPlacementSizes"
						checked={isAllSelected}
						onChange={handleSelectAll}
						className="select-all-placement-size"
						 />

					{adSizes.map((fld) => {
						return (
							<Field
								component={ReduxControls.Checkbox}
								type="checkbox"
								name={`base-sizes[${fld}]`}
								label={fld}
								key={`checkbox-${fld}`}
							 />
						);
					})}
				</div>
				<div className="checkbox-col custom">
					<CustomSizes
						formErrors={formErrors}
						customSizes={customSizes}
						errorMessages={errorMessages}
						modalName={formName}
						 />
				</div>
			</form>
		</div>
	);
}

const buildConceptSizes = (values, libraryId) => {
	let conceptData =  {
		conceptName: values.conceptName,
		conceptType: "HTML",
		creativeLibraryId: libraryId,
		sizes: [],
	};

	if(values?.['base-sizes']){
		Object.entries(values?.['base-sizes']).forEach((baseSize) => {
			let [width, height] = baseSize[0].split('x');
			if(baseSize[1] === true){
				conceptData.sizes.push({ width: parseInt(width), height: parseInt(height) });
			}
		});
	}
	if(values?.['custom-sizes']){
		values?.['custom-sizes'].forEach((size) => {
			conceptData.sizes.push({
				width: parseInt(size.width),
				height: parseInt(size.height),
			});
		});
	}
	return conceptData;
};

export function customValidate(values){
	let errors = {}
		, customSizes = values?.['custom-sizes']
		, customErrors = {};

	if(customSizes){
		let customSizesSet = new Set();

		customSizes.forEach((size, index) => {
			let { width, height } = size
				, formatted = `${width?.trim()}x${height?.trim()}`
				, customError = {}
				;

			if(width && height && customSizesSet.has(formatted) || adSizes.includes(formatted)){
				customError = {
					width: `Custom Placement Sizes - Placement sizes must be unique within the concept.`,
					height: `Custom Placement Sizes - Placement sizes must be unique within the concept.`,
				};
				customErrors[`custom-sizes[${index}]`] = customError;
			} else {
				customSizesSet.add(formatted);
			}
		});	//end customSizes.forEach()
	}	//end if(customSizes)

	if(Object.keys(customErrors).length){
		errors = {
			...errors,
			customErrors,
		};
	}	//end if(customErrorList.length)

	return errors;
}
